/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const g = /* @__PURE__ */ new Set(["children", "localName", "ref", "style", "className"]), v = /* @__PURE__ */ new WeakMap(), y = (t, o, s, i, l) => {
  const f = l == null ? void 0 : l[o];
  f === void 0 ? (t[o] = s, s == null && o in HTMLElement.prototype && t.removeAttribute(o)) : s !== i && ((d, a, u) => {
    let c = v.get(d);
    c === void 0 && v.set(d, c = /* @__PURE__ */ new Map());
    let n = c.get(a);
    u !== void 0 ? n === void 0 ? (c.set(a, n = { handleEvent: u }), d.addEventListener(a, n)) : n.handleEvent = u : n !== void 0 && (c.delete(a), d.removeEventListener(a, n));
  })(t, f, s);
}, S = ({ react: t, tagName: o, elementClass: s, events: i, displayName: l }) => {
  const f = new Set(Object.keys(i ?? {})), d = t.forwardRef((a, u) => {
    const c = t.useRef(/* @__PURE__ */ new Map()), n = t.useRef(null), p = {}, m = {};
    for (const [e, r] of Object.entries(a)) g.has(e) ? p[e === "className" ? "class" : e] = r : f.has(e) || e in s.prototype ? m[e] = r : p[e] = r;
    return t.useLayoutEffect(() => {
      if (n.current === null) return;
      const e = /* @__PURE__ */ new Map();
      for (const r in m) y(n.current, r, a[r], c.current.get(r), i), c.current.delete(r), e.set(r, a[r]);
      for (const [r, w] of c.current) y(n.current, r, void 0, w, i);
      c.current = e;
    }), t.useLayoutEffect(() => {
      var e;
      (e = n.current) == null || e.removeAttribute("defer-hydration");
    }, []), p.suppressHydrationWarning = !0, t.createElement(o, { ...p, ref: t.useCallback((e) => {
      n.current = e, typeof u == "function" ? u(e) : u !== null && (u.current = e);
    }, [u]) });
  });
  return d.displayName = l ?? s.name, d;
}, E = ({
  defineCustomElement: t,
  ...o
}) => (typeof t < "u" && t(), S(o)), h = ({
  hydrateModule: t,
  properties: o,
  tagName: s
}) => async (i) => {
  const { createComponentForServerSideRendering: l } = await import("./ssr.js");
  return l({
    tagName: s,
    properties: o,
    renderToString: (await t).renderToString
  })(i);
};
export {
  E as createComponent,
  h as createSSRComponent
};
